import React from 'react';
import ReactDOM from 'react-dom/client';
import './i18n';
import './styles/index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Service Worker (PWA)
// IMPORTANT : on n'enregistre le service worker qu'en PRODUCTION.
// En développement, un service worker met en cache une version périmée et
// fait recharger/clignoter la page en boucle contre le serveur de dev.
if ('serviceWorker' in navigator) {
  if (process.env.NODE_ENV === 'production') {
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register('/service-worker.js')
        .then((registration) => {
          console.log('SW registered:', registration.scope);

          // Check for updates every 30 minutes
          setInterval(() => {
            registration.update();
          }, 30 * 60 * 1000);

          // Handle updates
          registration.addEventListener('updatefound', () => {
            const newWorker = registration.installing;
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'activated') {
                // New version available - dispatch event for UI notification
                window.dispatchEvent(new CustomEvent('sw-updated'));
              }
            });
          });
        })
        .catch((error) => {
          console.log('SW registration failed:', error);
        });
    });
  } else {
    // Développement : désenregistrer tout service worker existant et vider les
    // caches (sinon un SW d'une session précédente fait clignoter la page).
    window.addEventListener('load', () => {
      navigator.serviceWorker.getRegistrations().then((registrations) => {
        registrations.forEach((registration) => registration.unregister());
      });
      if (window.caches && caches.keys) {
        caches.keys().then((names) => names.forEach((name) => caches.delete(name)));
      }
    });
  }
}
